// Crop a source image (object URL) to a square blob using pixel crop area from react-easy-crop.
export async function getCroppedBlob(imageSrc, pixelCrop, outSize = 512) {
  const img = await new Promise((res, rej) => {
    const i = new Image();
    i.onload = () => res(i);
    i.onerror = rej;
    i.src = imageSrc;
  });
  const canvas = document.createElement("canvas");
  canvas.width = outSize;
  canvas.height = outSize;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, outSize, outSize);
  const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", 0.9));
  return new File([blob], "avatar.jpg", { type: "image/jpeg" });
}

// Client-side image downscaling/compression to keep storage light and uploads fast.
export async function downscaleImage(file, maxDim = 1600, quality = 0.85) {
  try {
    if (!file || !file.type?.startsWith("image/")) return file;
    if (file.type === "image/gif") return file; // preserve animation
    const dataUrl = await new Promise((res, rej) => {
      const r = new FileReader();
      r.onload = () => res(r.result);
      r.onerror = rej;
      r.readAsDataURL(file);
    });
    const img = await new Promise((res, rej) => {
      const i = new Image();
      i.onload = () => res(i);
      i.onerror = rej;
      i.src = dataUrl;
    });
    const { width, height } = img;
    const scale = Math.min(1, maxDim / Math.max(width, height));
    // Already small enough and light — keep as-is
    if (scale === 1 && file.size < 400 * 1024) return file;
    const w = Math.round(width * scale);
    const h = Math.round(height * scale);
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, w, h);
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", quality));
    if (!blob || blob.size >= file.size) return file; // don't upsize
    const base = (file.name || "image").replace(/\.\w+$/, "");
    return new File([blob], `${base}.jpg`, { type: "image/jpeg" });
  } catch {
    return file; // any failure → upload original
  }
}
